<template>
  <div class="phenotype-disease-path-icon-page col-block width-full" :style="{ width: '76px' }">
    <div v-if="paths" class="phenotype-disease-path-icon-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div class="phenotype-disease-path-icon-block">
        <img :src="iconData.src" alt="">
        <div class="phenotype-disease-path-icon-count-container">
          <borCor
            :type="borCorType"
            :deviation="'15px 115px'"
            :background="'white'"
            :border="'#707070'"
            :radius="'0px'"
            :blockStyle="{
              padding: '6px 8px'
            }"
          >
            <div slot="trigger">
              <div class="phenotype-disease-path-icon-count center-block container-block">{{ paths.length - 1 > 0 ? paths.length - 1 : '' }}</div>
            </div>
            <div class="phenotype-disease-path-icon-count-content col-block" slot="content">
              <pathDetail
                :paths="paths"
              ></pathDetail>
            </div>
          </borCor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pathDetail from './pathDetail.vue'
import borCor from '../tool/borCor.vue'

export default {
  components: {
    pathDetail,
    borCor
  },
  props: {
    paths: {
      type: Array,
      default: () => null
    },
    borCorType: {
      type: String,
      default: () => 'bottom'
    }
  },
  computed: {
    iconData () {
      return this.paths ? {
        src: {
          '0': require('../../assets/phenotypePathIcons/0-path-icon.svg'),
          '1': require('../../assets/phenotypePathIcons/1-path-icon.svg')
        }[this.paths.length + ''] || require('../../assets/phenotypePathIcons/n-path-icon.svg')
      } : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/phenotypeDisease/pathIcon.vue